import actions from "~/modules/mortgage_progress/store/actions";
import getters from "~/modules/mortgage_progress/store/getters";
import mutations from "~/modules/mortgage_progress/store/mutations";

const state = {
  mortgage: null,
  mortgageProgresses: [],
  declineSelectionToSendToAgency: [],
  declineSelectionToBeApproved: [],
  declineSelectionApproved: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
